import Vue from 'vue'
import VueI18n from 'vue-i18n'
import pl from './i18n/pl'
import en from './i18n/en'
import cs from './i18n/cz'

Vue.use(VueI18n)

const messages = {
  en,
  pl,
  cs
}

export default new VueI18n({
  locale: 'pl', // set locale
  messages // set locale messages
})
